import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import "../../styles/meeting.css"; // We'll create this CSS file

const Meeting = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  const [activeAccordion, setActiveAccordion] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [meetingimages, setMeetingimages] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [mobtabs, setMobtabs] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const overlayRef = useRef(null);

  useEffect(() => {
    if (selectedImage) {
      // Scroll to the overlay when an image is selected
      overlayRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      // Prevent background scrolling
      document.body.style.overflow = "hidden";
    } else {
      // Re-enable background scrolling
      document.body.style.overflow = "auto";
    }
  }, [selectedImage]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/home.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        if (data.meetingimages) {
          setMeetingimages(data.meetingimages);
          setTabs(data.tabs);
          setMobtabs(data.mobtabs);
          setMeetings(data.meetings);
        } else {
          throw new Error("portfolioData not found in response");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  // Close modal when clicking outside image
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains("image-overlay")) {
      setSelectedImage(null);
    }
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };
  return (
    <div className="meeting-page">
      {/* Mobile Tabs - Horizontal Scrollable */}
      {isMobile && (
        <div className="mobile-tabs-container">
          <div className="mobile-tabs-scroll">
            {mobtabs.map((tab) => (
              <button
                key={tab.id}
                className={`mobile-tab ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      )}

      <div className="meeting-container">
        {/* Desktop Sidebar */}
        {!isMobile && (
          <div className="sidebarmeeting">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`sidebar-tab ${
                  activeTab === tab.id ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        <div className="content-area1">
          {activeTab === "tab1" && (
            <div className="tab-content active">
              <section>
                <div className="accordion-container">
                  {meetings.map((meeting, index) => (
                    <div
                      key={meeting.id}
                      className={`accordion-item ${
                        activeAccordion === index ? "active" : ""
                      }`}
                    >
                      <div
                        className="accordion-header"
                        onClick={() => toggleAccordion(index)}
                      >
                        <div className="header-content">
                          <div className="person-info">
                            <h3>{meeting.title}</h3>
                            {/* <div className="person-tag">{meeting.tag}</div> */}
                          </div>
                          <ul className="meeting-highlights">
                            <li>{meeting.highlight}</li>
                          </ul>
                          <div>
                            <a
                              href={meeting.pdf}
                              target="_blank"
                              rel="noreferrer"
                            >
                              Read more
                            </a>
                          </div>
                        </div>
                        <div className="accordion-icons">
                          {activeAccordion === index ? (
                            <FaChevronDown className="icon" />
                          ) : (
                            <FaChevronRight className="icon" />
                          )}
                        </div>
                      </div>
                      <div
                        className={`accordion-content ${
                          activeAccordion === index ? "open" : ""
                        }`}
                        style={{
                          maxHeight: activeAccordion === index ? `1000px` : "0"
                        }}
                      >
                        <div className="content-wrapper">
                          <div className="image-container">
                            <img
                              src={meeting.image}
                              alt={meeting.imageAlt}
                              className="meeting-image"
                              loading="lazy"
                            />
                            <div className="image-caption">
                              {meeting.imageCaption}
                            </div>
                          </div>
                          <div className="text-content">
                            {meeting.content.map((item, i) => {
                              if (typeof item === "string") {
                                return <p key={i}>{item}</p>;
                              } else if (item.quote) {
                                return (
                                  <div key={i} className="quote-box">
                                    <blockquote>{item.quote}</blockquote>
                                  </div>
                                );
                              }
                              return null;
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </div>
          )}

          {activeTab === "tab2" && (
            <div className="tab-content active">
              <div className="pdf-container">
                <iframe
                  src="./meetinpdf/ilayaraja.pdf"
                  title="இசைஞானி இளையராஜா PDF"
                  className="pdf-viewer"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          )}

          {activeTab === "tab3" && (
            <div className="tab-content active">
              <div className="pdf-container">
                <iframe
                  src="./meetinpdf/jeyakanthan.pdf"
                  title="இசைஞானி இளையராஜா PDF"
                  className="pdf-viewer"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          )}

          {activeTab === "tab4" && (
            <div className="tab-content active">
              <div className="pdf-container">
                <iframe
                  src="./meetinpdf/karunanithi.pdf"
                  title="இசைஞானி இளையராஜா PDF"
                  className="pdf-viewer"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          )}

          {activeTab === "tab5" && (
            <div className="tab-content active">
              <div className="pdf-container">
                <iframe
                  src="./meetinpdf/kulanthai.pdf"
                  title="இசைஞானி இளையராஜா PDF"
                  className="pdf-viewer"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          )}

          {activeTab === "tab6" && (
            <div className="tab-content active">
              <div className="pdf-container">
                <iframe
                  src="./meetinpdf/mayandi.pdf"
                  title="இசைஞானி இளையராஜா PDF"
                  className="pdf-viewer"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          )}

          {activeTab === "tab7" && (
            <div className="tab-content active">
              <div className="pdf-container">
                <iframe
                  src="./meetinpdf/ggg.pdf"
                  title="இசைஞானி இளையராஜா PDF"
                  className="pdf-viewer"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          )}

          {activeTab === "tab8" && (
            <div className="tab-content active">
              <div className="pdf-container">
                <iframe
                  src="./meetinpdf/tmkali.pdf"
                  title="இசைஞானி இளையராஜா PDF"
                  className="pdf-viewer"
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          )}

          {activeTab === "tab9" && (
            <div className="meetinggallery">
              {meetingimages.map((img, idx) => (
                <div
                  key={idx}
                  className="gallery-item"
                  onClick={() => setSelectedImage(img)}
                  style={{ transitionDelay: `${idx * 0.05}s` }}
                >
                  <div className="image-wrapper">
                    <img src={img.src} alt={img.caption} loading="lazy" />
                    <div className="overlay"></div>
                    <div className="caption">
                      <button className="view-btn">View</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
          {selectedImage && (
            <div
              className="image-overlay"
              onClick={handleOverlayClick}
              ref={overlayRef}
            >
              <div className="image-modal">
                <button
                  className="close-btn"
                  onClick={() => setSelectedImage(null)}
                >
                  &times;
                </button>
                <div className="image-content">
                  <img src={selectedImage.src} alt={selectedImage.caption} />
                  <p className="image-caption">{selectedImage.caption}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Meeting;
